module.exports = __webpack_public_path__ + "static/img/index_ad_hd.7b46cda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/index_ad_hd.jpg
// module id = vOHI
// module chunks = 192